import ko from 'knockout';
import templateMarkup from 'raw-loader!./flexquery-widget.html';
import moment from 'moment-timezone';


function FlexqueryWidget(params) {
    var self = this;
    self.params = params;

    this.observableOptions = params.observableOptions;

    self.columnOptionsObs = params.columnOptionsObs;

    var columnOptions = self.columnOptionsObs ? self.columnOptionsObs() : params.observableOptions().columnOptions;

    this.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;

    self.textboxClass = params.textboxClass ? params.textboxClass : 'flexquery-textbox';

    self.enableApply = ko.observable(false);

    self.widgetSignals = params.widgetSignals;
    if (self.widgetSignals && self.widgetSignals.dataLoaded) {
        self.widgetSignals.dataLoaded.dispatch();
    }

    if (self.widgetSignals.enableApply) {
        self.widgetSignals.enableApply.add(function () {
            self.enableApply(true);
        });
    }

    self.showFirstConditionAdd = ko.observable(true);
    self.subscriptions = [];

    self.message = ko.observable(null);

    self.multiSelectInitOptions = {
        includeSelectAllOption: true,
        numberDisplayed: 0,
        maxHeight: 200
    };

    self.typeaheadLimit = columnOptions.length;

    var masterlhs = columnOptions.sort(function (a, b) { return a.title < b.title ? -1 : 1; });
    var masteropsList = [{ text: 'in', value: 'in' }, { text: 'not in', value: 'notin' }];

    var isHistorical2 = params.panelTemplate.widgetType.indexOf("genericfilters-widget") > -1;

    var masteropsString = isHistorical2 ?
        [{ text: 'equals', value: '=' }, { text: 'contains', value: 'like' }, { text: 'in', value: 'in' }, { text: 'not in', value: 'notin' }]
        : [{ text: 'equals', value: '=' }, { text: 'contains', value: 'like' }];

    var masteropsNumeric = [{ text: 'equals', value: '=' }, { text: 'is less than', value: '<' }, { text: 'is or less than', value: '<=' }, { text: 'is greater than', value: '>' }, { text: 'is equal or greater than', value: '>=' }, { text: 'does not equal', value: '!=' }];
    var masteropsDatetime = [{ text: 'is prior to', value: '<' }, { text: 'is on or prior to', value: '<=' }, { text: 'is after', value: '>' }, { text: 'is on or after', value: '>=' }];
    var masterrhs = ['Rhs1', 'Rhs2'];
    self.conjunctions = ['AND', 'OR'];

    function LhsWithOperator(lhsColOpts) {

        var result = [];

        lhsColOpts.forEach(function (lhsitem) {

            if (lhsitem.hidden) {
                return;
            }

            var newobj = $.extend(true, {}, lhsitem);

            result.push(newobj);
        });

        self.typeaheadLimit = result.length;

        lhsColOpts.forEach(function (lhsitem) {

            if (lhsitem.hidden) {
                return;
            }

            var ops = masteropsString;

            if ((lhsitem.type === 'integer') || (lhsitem.type === 'decimal')) {
                ops = masteropsNumeric;
            } else if (lhsitem.type === 'list') {
                ops = masteropsList;
            } else if (lhsitem.type === 'datetime') {
                ops = masteropsDatetime;
            }

            ops.forEach(function (opitem) {

                if ((opitem.value === "in") || (opitem.value === "notin")) {
                    return;
                }

                var newobj = $.extend(true, {}, lhsitem);

                newobj.title = lhsitem.title + " " + opitem.text;
                newobj.opvalue = opitem.value;

                newobj.lhstitle = lhsitem.title;
                newobj.optitle = opitem.text;

                result.push(newobj);
            });
        });

        return result;
    }

    self.expressions = ko.observableArray(LhsWithOperator(masterlhs));

    if (self.columnOptionsObs) {
        self.subscriptions.push(self.columnOptionsObs.subscribe(function (newval) {

            columnOptions = newval;
            self.typeaheadLimit = columnOptions.length;

            masterlhs = newval.sort(function (a, b) { return a.title < b.title ? -1 : 1; });
            self.expressions(LhsWithOperator(masterlhs));
        }));
    } else {
        self.subscriptions.push(self.observableOptions.subscribe(function (newval) {
            columnOptions = newval.columnOptions;

            masterlhs = columnOptions.sort(function (a, b) { return a.title < b.title ? -1 : 1; });
            self.expressions(LhsWithOperator(masterlhs));
        }));
    }

    self.groups = ko.observableArray();

    function validRhs(type, resObj) {

        if (type === "datetime") {
            resObj.rhs = resObj.rhs.replace(',', '');
            return moment(resObj.rhs, 'YYYY-MM-DD', true).isValid() ||
                moment(resObj.rhs, 'M/D/YYYY', true).isValid() ||
                moment(resObj.rhs, 'YYYY-MM-DD H:mm', true).isValid() ||
                moment(resObj.rhs, 'M/D/YYYY H:mm', true).isValid() ||
                moment(resObj.rhs, 'YYYY-MM-DD H:mm:ss', true).isValid() ||
                moment(resObj.rhs, 'M/D/YYYY H:mm:ss', true).isValid()
            ;
        }

        if ((type !== "integer") && (type !== "decimal")) {
            return true;
        }

        if (resObj.op !== "in") {
            return $.isNumeric(resObj.rhs);
        }

        var tokens = resObj.rhs.split(',');

        for (var i = 0; i < tokens.length; i++) {
            if (!$.isNumeric(tokens[i])) {
                return false;
            }
        }

        return true;
    }

    function parseExpression(expression) {
        var result = {};

        var foundlength = 0;

        for (var i = 0; i < self.expressions().length; i++) {
            var item = self.expressions()[i];
            if (expression.toLowerCase().indexOf(item.title.toLowerCase()) === 0) {

                if (item.title.length < foundlength) {
                    continue;
                }

                foundlength = item.title.length;

                result.lhs = item.name;
                result.op = item.opvalue;

                result.rhs = expression.substring(item.title.length);

                result.lhstitle = item.lhstitle;
                result.optitle = item.optitle;

                if (result.rhs) {
                    result.rhs = result.rhs.trim();
                }

                if (!validRhs(item.type, result)) {
                    result.lhs = null;
                    result.op = null;
                    result.rhs = null;
                    foundlength = 0;
                }

            }
        }
        return result;
    }

    var savedWhereCondition = params.viewLevelOptions() && params.viewLevelOptions().WhereConditionObj;

    function loadSaveWhereCondition() {

        if (savedWhereCondition && (savedWhereCondition !== "1=1")) {

            var savedgroups = savedWhereCondition; // JSON.parse(savedWhereCondition);

            if (savedgroups.length > 0) {
                var groups = [];
                savedgroups.forEach(function (savedgroup) {
                    var conditions1 = [];
                    savedgroup.conditions.forEach(function (savedcondition) {
                        var newcondition = condition();
                        if (newcondition.loadvalues(savedcondition.id,
                            savedcondition.selectedLhs,
                            savedcondition.selectedOperator,
                            savedcondition.rhsText,
                            savedcondition.listtype,
                            savedcondition.valueType,
                            savedcondition.selectedRhs,
                            savedcondition.selectedConjunction,
                            savedcondition.conjunctionVisible,
                            savedcondition.hidden,
                            savedcondition.lhstitle,
                            savedcondition.optitle)) {
                            //
                            conditions1.push(newcondition);
                        }
                    });

                    groups.push(group(conditions1, savedgroup.selectedConjunction, savedgroup.conjunctionVisible));
                });

                self.groups(groups);
                self.showFirstConditionAdd(false);
            } else {
                self.groups([group()]);

            }
        } else {
            self.showFirstConditionAdd(true);
            self.groups([group()]);
        }
    }

    loadSaveWhereCondition();

    self.subscriptions.push(params.viewLevelOptions.subscribe(function () {
        savedWhereCondition = params.viewLevelOptions() && params.viewLevelOptions().WhereConditionObj;
        loadSaveWhereCondition();
    }));

    self.addFirstCondition = function () {
        self.groups([group()]); self.showFirstConditionAdd(false);
    };

    function FindColumnOption(name, columnOptions1) {
        var result = null;
        for (var i = 0; i < columnOptions1.length; i++) {
            if (columnOptions1[i].name.toLowerCase() === name.toLowerCase()) {
                result = columnOptions1[i];
                break;
            }
        }
        return result;
    }

    function FindOptText(opslist, selOp) {
        if (opslist && selOp) {

            for (var i = 0; i < opslist.length; i++) {

                if (opslist[i].value === selOp) {
                    return opslist[i].text;
                }

            }
        }

        return "";
    }

    function group(conditionsval, selconj, conjvis) {
        var newgroup = {
            metadata: { expressions: self.expressions },
            expression: ko.observable(),
            conditions: ko.observableArray(
                conditionsval && (conditionsval.length > 0) ? conditionsval : []),
            selectedConjunction: ko.observable(selconj),
            conjunctionVisible: ko.observable(conjvis === null ? false : conjvis),
            addCondition: function () {
                this.conditions.push(condition());
                this.conditions()[this.conditions().length - 2].conjunctionVisible(true);
            },
            removeCondition: function (data) {
                newgroup.conditions.remove(data);
                self.enableApply(true);
                if (newgroup.conditions().length === 1) {
                    newgroup.conditions()[0].conjunctionVisible(false);
                }
            }
        };

        newgroup.expression.subscribe(function (newvalue) {
            if (!newvalue) {
                return;
            }

            var conditionTokens = parseExpression(newvalue);

            if (!conditionTokens.lhs || !conditionTokens.op || !conditionTokens.rhs) {
                return;
            }

            var newcondition = condition();

            newcondition.loadMode = true;
            newcondition.selectedLhs(conditionTokens.lhs);
            newcondition.selectedOperator(conditionTokens.op);
            newcondition.rhsText(conditionTokens.rhs);

            newcondition.lhstitle = conditionTokens.lhstitle;
            newcondition.optitle = conditionTokens.optitle;

            newgroup.conditions.push(newcondition);
            newgroup.expression("");
            newcondition.loadMode = false;

            self.enableApply(true);
        });

        return newgroup;
    }

    var newconditionid = 1;

    function condition() {
        var newcondition = {
            id: newconditionid++,
            metadata: { lhs: masterlhs, rhs: masterrhs, conjunctions: self.conjunctions, expressions: self.expressions },
            selectedLhs: ko.observable(),
            selectedOperator: ko.observable('='),
            rhsText: ko.observable(''),
            rhsCount: ko.observable(''),
            operators: ko.observableArray(masteropsString),
            listtype: ko.observable(false),
            valueType: ko.observable('text'),
            selectedRhs: ko.observableArray(),
            selectedConjunction: ko.observable('AND'),
            conjunctionVisible: ko.observable(false),
            hidden: ko.observable(false),
            lhstitle: '',
            optitle: '',
            loadvalues: function (sid, selLhs, selOp, rhstext, listtp, valtype, selrhs, selconj, conjvis, hiddn, lhsttl, opttl) {

                var colopt = FindColumnOption(selLhs, masterlhs);
                if (!colopt) {
                    console.log('Invalid column: ' + selLhs);
                    return false;
                }

                this.loadMode = true;
                this.id = sid;
                this.selectedLhs(selLhs);
                this.rhsText(rhstext);
                this.listtype(listtp);
                this.valueType(valtype);
                this.selectedRhs(selrhs);
                this.selectedConjunction(selconj);
                this.conjunctionVisible(conjvis);
                this.hidden(hiddn ? hiddn : false);
                this.lhstitle = lhsttl;
                this.optitle = opttl;

                if (selrhs && (selrhs.length > 0)) {
                    this.rhsCount('(' + selrhs.length + ' selected)');
                }

                if (valtype === 'numeric') {
                    this.operators(masteropsNumeric);
                } else if (valtype === 'list') {
                    this.operators(masteropsList);
                } else if ((selOp === 'in') || (selOp === 'notin')) {
                    this.operators(masteropsString);
                }

                if ((valtype === 'text') || (selLhs && !lhsttl)) {
                    this.lhstitle = colopt.title;
                    if (colopt.type === 'datetime') {
                        this.operators(masteropsDatetime);
                    }
                }

                if (selOp) {
                    var allops = this.operators();
                    var testop = $.grep(allops,
                        function (n, j) {
                            return (n.value === selOp);
                        });

                    if (!testop || (testop.length === 0)) {
                        console.log('Invalid operator: ' + selOp);
                        this.loadMode = false;
                        return false;
                    }
                }

                this.selectedOperator(selOp);

                if (selOp && !opttl) {
                    this.optitle = FindOptText(this.operators(), selOp);
                }
                this.loadMode = false;
                return true;
            }
        };

        newcondition.selectedLhs.subscribe(function (newvalue) {
            if (!newvalue) {
                return;
            }
            var colopt = FindColumnOption(newvalue, masterlhs);
            newcondition.lhstitle = colopt.title;

            if (colopt.hidden) {
                newcondition.hidden(true);
            }
            else {
                newcondition.hidden(false);
            }

            if ((colopt.type === 'integer') || (colopt.type === 'decimal')) {
                newcondition.operators(masteropsNumeric);
                newcondition.listtype(false);
                newcondition.valueType('numeric');
            } else if (colopt.type === 'list') {
                newcondition.operators(masteropsList);
                newcondition.listtype(true);
                newcondition.valueType('numeric');
            }
            else if (colopt.type === 'datetime') {
                newcondition.operators(masteropsDatetime);
                newcondition.listtype(false);
                newcondition.valueType('text');
            } else {
                newcondition.operators(masteropsString);
                newcondition.listtype(false);
                newcondition.valueType('text');
            }
            newcondition.selectedOperator(newcondition.operators()[0].value);
            newcondition.optitle = newcondition.operators()[0].text;
            newcondition.selectedOperator.valueHasMutated();
        });

        newcondition.selectedOperator.subscribe(function (newvalue) {
            if (!newcondition.loadMode) {
                self.enableApply(true);
            }
        });

        newcondition.rhsText.subscribe(function (newvalue) {
            if (!newcondition.loadMode) {
                self.enableApply(true);
            }
        });

        return newcondition;
    }

    self.addGroup = function () {
        self.groups.push(group());
        self.groups()[self.groups().length - 2].conjunctionVisible(true);
    };

    function setQuery() {
        if ((self.groups().length === 0) || (self.groups()[0].conditions().length === 0)) {
            savedWhereCondition = [];
            params.viewLevelOptions([]);
            return;
        }


        var groupsCopy = JSON.parse(ko.toJSON(self.groups()));

        for (var i = 0; i < groupsCopy.length; i++) {

            var groupcopy = groupsCopy[i];

            for (var j = 0; j < groupcopy.conditions.length; j++) {

                var conditioncopy = groupcopy.conditions[j];

                delete conditioncopy.metadata;
                delete conditioncopy.operators;

            }

            delete groupsCopy[i].metadata;
            delete groupsCopy[i].expression;

        }

        var whereCondition = groupsCopy;

        savedWhereCondition = whereCondition;

        params.viewLevelOptions(whereCondition);
    }

    self.applyQuery = function () {

        self.enableApply(false);
        setTimeout(setQuery, 20);
    };

    self.subscriptions.push(self.enableApply.subscribe(function (val) {

        if (val) {
            self.applyQuery();
        }

    }));

    self.resetQuery = function () {

        loadSaveWhereCondition();
    };

}


// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
FlexqueryWidget.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });

};

export default { viewModel: FlexqueryWidget, template: templateMarkup };
